import { ClockCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { getRemainingDuration } from '@/services/api';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => null;

const baseStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '2px 10px',
  fontSize: 14,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  borderRadius: 4,
};

export const Question: React.FC = () => {
  const [remaining, setRemaining] = useState<number | null>(null);

  useEffect(() => {
    getRemainingDuration()
      .then((res) => {
        setRemaining(res?.remainingMinutes ?? 0);
      })
      .catch(() => {
        setRemaining(0);
      });
  }, []);

  if (remaining === null) return null;

  const isOverdue = remaining < 0;
  const displayMinutes = Math.abs(remaining);

  return (
    <Tooltip title={isOverdue ? '余额不足，点击立即充值' : '立即充值'}>
      <span
        onClick={() => history.push('/statistic/recharge')}
        style={{
          ...baseStyle,
          color: isOverdue ? '#cf1322' : '#0958d9',
          fontWeight: 500,
          background: isOverdue ? '#fff2f0' : '#f0f5ff',
        }}
      >
        {isOverdue ? (
          <>
            <ExclamationCircleOutlined style={{ fontSize: 14 }} />
            欠费时长：{displayMinutes}分钟
          </>
        ) : (
          <>
            <ClockCircleOutlined style={{ fontSize: 14 }} />
            剩余时长：{displayMinutes}分钟
          </>
        )}
      </span>
    </Tooltip>
  );
};
